var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpBPhotosIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 2.05719 1 1.58579 1.29289 1.29289C1.58579 1 2.05719 1 3 1H6.5C7.44281 1 7.91421 1 8.20711 1.29289C8.5 1.58579 8.5 2.05719 8.5 3V6.5C8.5 7.44281 8.5 7.91421 8.20711 8.20711C7.91421 8.5 7.44281 8.5 6.5 8.5H3C2.05719 8.5 1.58579 8.5 1.29289 8.20711C1 7.91421 1 7.44281 1 6.5V3Z",
    stroke: "#05073C",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35838 5.40005C8.40636 5.28029 8.35085 5.14517 8.23371 5.0911C8.21708 5.08342 8.20049 5.07608 8.18385 5.06906C7.62436 4.83286 6.99316 4.83287 6.43368 5.06906C6.24503 5.1487 6.0625 5.26851 5.75545 5.47006L5.73163 5.48569L5.60284 5.57021C5.47318 5.65531 5.42736 5.68479 5.38887 5.70368C5.08042 5.85501 4.70858 5.77741 4.48642 5.51533C4.45869 5.48262 4.42849 5.43727 4.34369 5.30741L4.3315 5.28875C4.18177 5.05943 4.09329 4.92393 4.00238 4.81668C3.33589 4.03044 2.22037 3.79762 1.29502 4.25163C1.27357 4.26215 1.3272 4.23584 1.31846 4.24057C1.20987 4.29931 1.07702 4.49199 1.06074 4.61437C1.05942 4.62422 1.06536 4.56026 1.06299 4.58585C1.05798 4.63978 1.05542 4.69442 1.05542 4.74966C1.05542 4.8548 1.17216 4.90915 1.26048 4.8521C1.3798 4.77503 1.45056 4.73225 1.51526 4.70051C2.23497 4.3474 3.10259 4.52848 3.62098 5.14C3.68907 5.22032 3.7596 5.32743 3.92505 5.58079L3.9351 5.59619L3.93511 5.5962C4.00606 5.70489 4.05438 5.77891 4.10501 5.83864C4.47529 6.27544 5.09502 6.40479 5.6091 6.15256C5.67941 6.11807 5.7533 6.06956 5.86181 5.99832L5.87718 5.98823L6.00598 5.9037C6.34391 5.68192 6.4866 5.58945 6.62814 5.52969C7.06329 5.34599 7.55423 5.34599 7.98939 5.52969C8.12789 5.58816 8.29521 5.55385 8.35239 5.41481C8.35441 5.4099 8.35641 5.40498 8.35838 5.40005Z",
    fill: "#05073C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.625,
    cy: 2.875,
    r: 0.625,
    fill: "#05073C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpBPhotosIconBlack);
export default __webpack_public_path__ + "static/media/cp-b-photos-icon-black.e419c6fbb250f1dbde995006a6c2a44d.svg";
export { ForwardRef as ReactComponent };